<template>
  <van-nav-bar
    @click-left="onClickLeft"
    @click-right="onClickRight"
  >
    <template #left>
      <van-icon
        name="arrow-left"
        size="20"
        color="#bc4853"
      />
    </template>
    <template #title>
      <slot name="title">
        <span>{{ navTitle }}</span>
      </slot>
    </template>
    <template #right>
      <van-icon
        name="wap-home-o"
        size="20"
        color="#bc4853"
      />
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: "CustomNavBar",
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    navTitle() {
      return this.title
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      this.$store.commit("SET_ACTIVE", '/');
      this.$router.push({ path: "/" });
    },
  },
};
</script>
